import {generateAsyncActionCreators} from '../core/reduxUtils';
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';

const getSearchProductsActionCreators = generateAsyncActionCreators(
  'GET_SEARCH_PRODUCTS',
  (params, cookies, headers) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
    cookies,
    headers
  })
);

const getNextSearchProductsActionCreators = generateAsyncActionCreators(
  'GET_NEXT_SEARCH_PRODUCTS',
  (params, cookies, headers) => ({
    params: {
      ...params,
      [PAGINATION_PARAM_NAMES.PAGE]: params[PAGINATION_PARAM_NAMES.PAGE] || 1,
    },
    cookies,
    headers
  })
);


const actionCreators = {
  getSearchProducts: {
    ...getSearchProductsActionCreators,
  },

  getNextSearchProducts: {
    ...getNextSearchProductsActionCreators,
  },


  resetSearchPageState() {
    return {
      type: 'RESET_SEARCH_PAGE_STATE',
      payload: {},
    };
  },
};

export {
  actionCreators,
  getSearchProductsActionCreators,
  getNextSearchProductsActionCreators,
};
